// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".toolbar{position:sticky;top:0;background-color:#fff;border-bottom:1px solid #ccc;z-index:10;padding:10px}.ql-color,.ql-header,.ql-size{position:relative;z-index:20}[ref=quillEditor]{border:1px solid #ccc;padding:10px;background-color:#f9f9f9;height:400px;overflow-y:auto}", ""]);
// Exports
module.exports = exports;
